<div class="bg-th-yellow mt-0 container-fluid">

  <div class=" d-flex justify-content-between align-content-center h-35">

    <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

    <span class="my-auto f16 fw-bold me-2"> {{ bServiceAreas ? ' حوزه های خدمتی ' : 'ثبت مدارس' }}</span>

  </div>

</div>

<section class="container dirI">

  <div class="row gy-2 gy-md-0 d-flex justify-content-between m-2 m-md-4">

    <div class="col-md-3 col-12">

      <div class="input-group mb-1">

        <input type="text" class="form-control rounded" placeholder=" جستجو ..."
          (keyup)="searchbox($event.target.value)">

        <button class="btn btn-primary rounded" type="submit">

          <i class="fa fa-search"></i>

        </button>

      </div>

    </div>

    <div class="col-md-3 col-12 ">

      <button class="w-100 btn btn-outline-success" data-bs-toggle="modal" (click)="editMode=false; addSa()"
        data-bs-target="#editSA"> افزودن &nbsp;

        <i class="fa fa-plus-circle"></i>

      </button>

    </div>

  </div>

  <div class="table-responsive border border-2 p-2 " style="max-height: 84vh;">

    <div class="col-12 px-3 mb-0">

      <p> تعداد کل : {{ serviceAreas?.length | faNum }} </p>

    </div>

    <div class="col-12 px-3 pb-3">

      <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

    </div>

    <table class="table table-striped" *ngIf="serviceAreas?.length > 0">
      <thead class=" bg-white">
        <tr class="text-center">

          <th scope="col" class="position-sticky text-center">عملیات</th>

          <th scope="col" class="position-sticky" (click)="sortBy(0)"> 
            
              {{bServiceAreas ? ' نام حوزه ' : 'نام مدرسه'}}
            
              &nbsp; <i class="fa fa-sort-amount-asc pointer"></i>
          
          </th>

          <ng-container *ngIf="!bServiceAreas">

            <th scope="col" class="position-sticky"> شهر </th>

            <th scope="col" class="position-sticky"> ناحیه </th>

            <th scope="col" class="position-sticky"> نوع مدرسه </th>

            <th scope="col" class="position-sticky"> مقطع </th>

            <th scope="col" class="position-sticky"> جنسیت </th>

          </ng-container>

        </tr>
      </thead>
      <tbody>
        <tr [id]="'row'+item.iMobileDomain" class="pointer text-center" *ngFor="let item of serviceAreas;let i=index">

          <th class="d-flex flex-wrap justify-content-center gap-2 f18">

            <i class="fa fa-ellipsis-h fa-lg pointer me-2" aria-hidden="true" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"></i>

            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="z-index: 10001!important;">

                <!-- ویرایش -->

                <li class="dropdown-li" (click)="editMode=true; openEditModal(item)" data-bs-toggle="modal" data-bs-target="#editSA">

                  <i class="fa fa fa-edit fa-lg" title="ویرایش"></i>

                  <span> ویرایش </span>

                </li>

                <!-- حذف -->

                <li class="dropdown-li" (click)="DeleteSA(item)">

                  <i class="fa fa-trash fa-lg" title="حذف"></i>

                  <span> حذف </span>

                </li>

                <ng-container *ngIf="!bServiceAreas">

                    <!-- دسترسی های مدرسه -->
    
                    <li *ngIf="bSchoolAbility" class="dropdown-li" (click)="showAbility(item)">
    
                      <i class="fa fa-unlock-alt fa-lg" title="دسترسی های مدرسه"></i>
    
                      <span> دسترسی های مدرسه </span>
    
                    </li>

                    <!-- شکایات قابل دسترسی -->
    
                    <li *ngIf="bSchoolTiket" class="dropdown-li" (click)="showTicket(item)">
    
                      <i class="fa fa-commenting fa-lg" title="شکایات قابل دسترسی"></i>
    
                      <span> شکایات قابل دسترسی </span>
    
                    </li>

                    <!-- برنامه روزانه -->
    
                    <li class="dropdown-li" (click)="show_Schedule(item)">
    
                      <i class="fa fa-calendar-plus-o fa-lg" title="برنامه روزانه"></i>
    
                      <span> برنامه روزانه </span>
    
                    </li>

                </ng-container>

              </ul>

          </th>

          <th class="text-dark f14">{{item.strComment}}</th>

          <ng-container *ngIf="!bServiceAreas">

              <th class="text-dark f14">{{item.strCityName}}</th>

              <th class="text-dark f14">{{item.strEducationDistrict_strComment}}</th>

              <th class="text-dark f14">{{item.strSchoolType_strComment}}</th>

              <th class="text-dark f14">{{item.strEducationLevel_strComment}}</th>

              <th class="text-dark f14">{{item.strGender}}</th>
              
          </ng-container>

        </tr>
      </tbody>
    </table>
    <div *ngIf="serviceAreas?.length == 0" class="d-flex justify-content-center align-items-center">
      <strong>موردی یافت نشد...</strong>
    </div>
  </div>

</section>

<!-- Edit and Add Modal -->

<div class="modal fade" id="editSA" tabindex="-1" aria-labelledby="AddSA" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between dirI">
        <h5 class="modal-title" id="addUserLabel">{{editMode && bServiceAreas? 'ویرایش حوزه': editMode &&
          !bServiceAreas? 'ویرایش مدرسه': bServiceAreas ? 'افزودن حوزه' : 'افزودن مدرسه'}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">

        <div class="container-fluid">

          <div class="row">

            <form [formGroup]="SAInputs" class="dirI">

              <div class="form-group row mb-2">

                <div class="form-group row">

                  <label for="hoze" class="col-sm-3 col-form-label">

                    {{bServiceAreas ? 'نام حوزه : ' : ' نام مدرسه : ' }}

                  </label>

                  <div class="col-sm-9">

                    <input type="text" class="form-control" name="1" id="1" formControlName="strComment">

                  </div>

                </div>

              </div>

              <ng-container *ngIf="!bServiceAreas">
                                
                <div class="form-group row mb-2">

                  <label for="hoze" class="col-sm-3 col-form-label"> شهر :</label>

                  <div class="col-sm-9">

                    <input type="search" name="selectedCity" autocomplete="off" class="form-control"
                      [(ngModel)]="searchT_City" [ngModelOptions]="{standalone: true}" (input)="filterCity()" />

                    <ul class="list-group" style="max-height: 200px;overflow: auto;">

                      <li class="list-group-item pointer" *ngFor="let item of filteredCity" [@fadeAnimation]
                        (click)="selectedCity(item)">{{ item.strCityName }}</li>

                    </ul>

                  </div>

                </div>

                <div class="form-group row mb-2">

                  <label for="hoze" class="col-sm-3 col-form-label"> ناحیه آموزش و پرورش :</label>

                  <div class="col-sm-9">

                    <select class="w-100 form-control" formControlName="tiEducationDistrict">

                      <option *ngFor="let item of lstDistrict" [value]="item.tiEducationDistrict">

                        {{ item.strComment }}

                      </option>

                    </select>

                  </div>

                </div>

                <div class="form-group row mb-2">

                  <label for="hoze" class="col-sm-3 col-form-label"> نوع مدرسه :</label>

                  <div class="col-sm-9">

                    <select class="w-100 form-control" formControlName="tiSchoolType">

                      <option *ngFor="let item of lstSchoolType" [value]="item.tiSchoolType">

                        {{ item.strComment }}

                      </option>

                    </select>

                  </div>

                </div>

                <div class="form-group row mb-2">

                  <label for="hoze" class="col-sm-3 col-form-label"> مقطع تحصیلی :</label>

                  <div class="col-sm-9">

                    <select class="w-100 form-control" formControlName="tiEducationLevel">

                      <option *ngFor="let item of lstLevel_List" [value]="item.tiEducationLevel">

                        {{ item.strComment }}

                      </option>

                    </select>

                  </div>

                </div>

                <div class="form-group row mb-2">

                  <label for="hoze" class="col-sm-3 col-form-label"> جنسیت :</label>

                  <div class="col-sm-9">

                    <select class="w-100 form-control" formControlName="tiGender">

                      <option value="-1"> نامشخص </option>

                      <option value="0"> پسرانه </option>

                      <option value="1"> دخترانه </option>

                      <option value="2"> مختلط </option>

                    </select>

                  </div>

                </div>

                <div class="form-group row mb-2">
                  <label for="radious" class="col-sm-3 col-form-label" style="margin-right: auto;"> محدوده مدرسه ( متر )
                    :</label>
                  <div class="col-sm-9">
                    <input type="number" class="form-control" id="3" name="3" formControlName="iRadious">
                  </div>
                </div>

                <div class="form-group row mb-2">

                  <label for="radious" class="col-sm-3 col-form-label" style="margin-right: auto;"> آدرس :</label>

                  <div class="col-sm-9 position-relative">

                    <input type="text" class="form-control" id="strAddress" formControlName="strAddress">

                    <button class="mx-2 btn btn-warning location-button rounded position-absolute" type="button"
                      (click)="getAddress()">

                      <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                    </button>

                  </div>

                </div>

                <div class="form-group row mb-2">

                  <label class="col-sm-3 col-form-label"> طول جغرافیایی : </label>

                  <div class="col-sm-9">

                    <input type="text" dir="ltr" disabled class="form-control" formControlName="fLon">

                  </div>

                </div>

                <div class="form-group row mb-2">

                  <label class="col-sm-3 col-form-label"> عرض جغرافیایی : </label>

                  <div class="col-sm-9">

                    <input dir="ltr" type="text" disabled class="form-control" formControlName="fLat">

                  </div>

                </div>

                <div class="form-group row mb-2">
                  <label for="payCo" class="col-sm-3 col-form-label"> درگاه پرداخت مدرسه : </label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" id="10" name="10" formControlName="strTerminalID">
                  </div>
                </div>

                <div class="form-group row mb-2">
                  <label for="bank" class="col-sm-3 col-form-label">نام بانک درگاه:</label>
                  <div class="d-flex align-items-center col-sm-9">
                    <input type="text" class="form-control" id="11" name="11" formControlName="strBankName">
                  </div>
                </div>

                <div class="form-group row mb-2">
                  <label for="med" class="col-sm-3 col-form-label">فایل مدیا:</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" id="13" placeholder="آدرس URL..." name="13"
                      formControlName="strSchoolBusMedia">
                  </div>
                </div>

                <!-- کلاس بر خط -->

                <div class="form-group row mb-2">

                  <label class="col-sm-3 col-form-label"> کلاس بر خط : </label>

                  <div class="col-sm-9">

                    <input type="text" class="form-control text-end" formControlName="strBBBServerURL">

                  </div>

                </div>

                <!-- کلید کلاس بر خط -->

                <div class="form-group row mb-2">

                  <label class="col-sm-3 col-form-label"> کلید کلاس بر خط : </label>

                  <div class="col-sm-9">

                    <input type="text" class="form-control text-end" formControlName="strBBBSecretKey">

                  </div>

                </div>

              </ng-container>

            </form>

          </div>

        </div>

      </div>

      <div class="modal-footer dirI">
        <button type="button" class="btn btn-success" (click)="EditSA()">{{editMode? 'ویرایش': 'ثبت'}}<i
            class="fa fa-check-square-o"></i></button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">لغو <i class="fa fa-close"></i></button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="maplat" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
  data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered modal-xl">

    <div class="modal-content p-1">

      <div class="modal-header dirI">

        <h5 class="modal-title">ثبت موقعیت</h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

      </div>

      <div id="map" class="position-sticky w-100 " style="height: 500px;">

        <div [formGroup]="latoLong" class="d-flex justify-content-around position-absolute dirI bg-th-yellow w-100 p-1"
          style="z-index: 1000; margin-bottom: 10px;">

          <div class="mx-1">

            <label for="lat">عرض جغرافیایی: </label>

            <input readonly id="lat" type="text" formControlName="latIn" class="mx-2" #lat>

          </div>

          <div class="mx-1">

            <label for="lon">طول جغرافیایی: </label>

            <input readonly id="lon" type="text" formControlName="longIn" class="mx-2">

          </div>

        </div>

        <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

      </div>

      <button (click)="confirmLatol()" *ngIf="lat.value != ''" data-bs-dismiss="modal" class="btn btn-success">تایید <i
          class="fa fa-check"></i></button>

    </div>

  </div>

</div>

<div class="modal fade" id="access_School" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered modal-lg">

    <div class="modal-content p-1">

      <div class="modal-header dirI">

        <h5 class="modal-title"> دسترسی های مدرسه </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

      </div>

      <div>


        <div dir="rtl" class="table-responsive " style="max-height: 500px;overflow: auto;">

          <table class="table table-striped">

            <thead class="position-sticky top-0 bg-white">

              <tr class="col-12 text-center">

                <th> انتخاب </th>

                <th> دسترسی </th>

              </tr>

            </thead>

            <tbody>

              <tr class="text-center col-12" *ngFor="let item of list_ability">

                <td><input type="checkbox" (change)="onCheckbox_($event.target.checked,item)"
                    [checked]="item.bHas == 1 ? true : false "></td>

                <td>{{item.strComment | faNum}}</td>

              </tr>

            </tbody>

          </table>

        </div>



      </div>

    </div>

  </div>

</div>

<div class="modal fade" id="ticket_School" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered modal-lg">

    <div class="modal-content p-1">

      <div class="modal-header dirI">

        <h5 class="modal-title"> شکایات قابل دسترسی </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

      </div>

      <div>

        <div dir="rtl" class="table-responsive " style="max-height: 500px;overflow: auto;">

          <table class="table table-striped" *ngIf="list_Ticket.length > 0">

            <thead class="position-sticky top-0 bg-white">

              <tr class="col-12 text-center">

                <th> انتخاب </th>

                <th> دسترسی </th>

                <th> نوع </th>

              </tr>

            </thead>

            <tbody>

              <tr class="text-center col-12" *ngFor="let item of list_Ticket">

                <td><input type="checkbox" (change)="onCheckbox_Ticket($event.target.checked,item)"
                    [checked]="item.bHas == 1 ? true : false "></td>

                <td>{{item.strComment | faNum}}</td>

                <td>{{item.strType | faNum}}</td>

              </tr>

            </tbody>

          </table>

          <div class="text-center p-3" *ngIf="list_Ticket.length == 0">

            موردی یافت نشد


          </div>

        </div>



      </div>

    </div>

  </div>

</div>

<!-- برنامه ریزی روزانه -->

<div class="modal fade" id="Std_Schedule_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-lg" style="direction: rtl;">

    <div class="modal-content">

      <div class="modal-header">

        <h5 class="modal-title" id="exampleModalLabel"> {{ editMode ? 'ویرایش برنامه ریزی' : bAddSchedule ? 'افزودن
          برنامه ریزی' : 'برنامه ریزی' }} </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

      </div>

      <div class="modal-body">

        <div *ngIf="!bAddSchedule" class="col-12 text-end mb-2">

          <button class="btn btn-success px-3" (click)="showSchedule_Add()"> افزودن </button>

        </div>

        <div class="section" style="max-height:calc(80vh - 170px);overflow: auto;">

          <!-- جدول برنامه ریزی ها -->

          <ng-container *ngIf="!bAddSchedule;else addSchedule">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel_Schedule">

              <thead>

                <tr class="">

                  <th class="text-center col-1"> # </th>

                  <th class="text-center"> عملیات </th>

                  <th class="text-center"> عنوان </th>

                  <th class="text-center"> ساعت شروع </th>

                  <th class="text-center"> ساعت پایان </th>

                  <th class="text-center"> مدت </th>

                </tr>

              </thead>

              <tbody>

                <tr class="col-12 text-center" *ngFor="let item of lst_Schedule;let i = index">

                  <th> {{ i + 1 | faNum }} </th>

                  <th class="d-flex flex-wrap justify-content-center gap-2 f18">

                    <i class="btn btn-outline-primary fa fa-edit" (click)="showSchedule_Add(item,i)"></i>

                    <i class="btn btn-outline-danger fa fa-trash" (click)="removeSchedule(item,i)"></i>

                  </th>

                  <td> {{ item.strTitle | faNum }} </td>

                  <td> {{ item.strSTime | faNum }} </td>

                  <td> {{ item.strETime | faNum }} </td>

                  <td> {{ item.iDuration | faNum }} </td>

                </tr>

              </tbody>

            </table>

          </ng-container>

          <!-- فرم افزودن, ویرایش برنامه ریزی -->

          <ng-template #addSchedule>

            <div [formGroup]="mdl_Schedule" class="container-fluid row gx-2 gy-2 p-2">

              <!-- عنوان -->

              <div class="position-relative col-12 p-2">

                <label class="mb-2 text-muted"> عنوان </label>

                <input class="form-control p-2 text-center" formControlName="strTitle">

              </div>

              <!-- ساعت شروع -->

              <div class="position-relative col-12 col-md-4 p-2">

                <label class="mb-2 text-muted" style="z-index: 10;"> ساعت شروع </label>

                <div class="input-group clockpicker">

                  <input type="text" class="form-control p-2 text-center" id="Stime" formControlName="strSTime"
                    autocomplete="off">

                  <span class="input-group-addon">

                    <span class="glyphicon glyphicon-time"></span>

                  </span>

                </div>

              </div>

              <!-- ساعت پایان -->

              <div class="position-relative col-12 col-md-4 p-2">

                <label class="mb-2 text-muted" style="z-index: 10;"> ساعت پایان </label>

                <div class="input-group clockpicker">

                  <input type="text" class="form-control p-2 text-center" id="Etime" formControlName="strETime"
                    autocomplete="off">

                  <span class="input-group-addon">

                    <span class="glyphicon glyphicon-time"></span>

                  </span>

                </div>

              </div>

              <!-- مدت -->

              <div class="position-relative col-12 col-md-4 p-2">

                <label class="mb-2 text-muted"> مدت </label>

                <input class="form-control p-2 text-center" oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                  formControlName="iDuration">

              </div>


            </div>

          </ng-template>

        </div>

      </div>

      <div *ngIf="bAddSchedule" class="modal-footer d-flex justify-content-start">

        <button class="btn" [ngClass]="editMode ? 'btn-primary' : 'btn-success' " (click)="saveSchedule()">

          &nbsp; {{ editMode ? 'ویرایش' : 'ذخیره' }} &nbsp;

        </button>

        <button class="btn btn-outline-danger" (click)="bAddSchedule = false;editMode=false">

          &nbsp; بازگشت &nbsp;

        </button>

      </div>

    </div>

  </div>

</div>